import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
const taskVuex = createNamespacedHelpers("task");
const dailyVuex = createNamespacedHelpers("daily");
export default {
  name: "earn",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting']),
    ...userVuex.mapState(["userData", "userLocation"]),
    ...taskVuex.mapState(["taskList", "advList", "selectTab"]),
    ...dailyVuex.mapState(["summary"])
  },
  data() {
    return {
      popUpGoldShow: false,
      popCoinHeroShow: false,
      popBindWalletShow: false,
      popBindOkxWalletShow: false,
      taskNum: 0,
      extraTaskNum: 0,
      checkNum: 0,
      timeVal: null,
      stimeVal: null,
      popEarnTipShow: false,
      isPopRewardResultShow: false,
      itemData: {},
      selectRow: {},
      iframeShow: false,
      iframeUrl: "",
      fadvList: []
    };
  },
  beforeRouteLeave(to, from, next) {
    clearTimeout(this.timeVal);
    clearTimeout(this.stimeVal);
    this.popBindWalletShow = false;
    this.popBindOkxWalletShow = false;
    this.popUpGoldShow = false;
    this.popCoinHeroShow = false;
    this.isPopRewardResultShow = false;
    this.popEarnTipShow = false;
    this.iframeShow = false;
    this.$nextTick(() => {
      next();
    });
  },
  watch: {
    "userData": {
      handler() {
        this.checkTask();
      },
      deep: true,
      immediate: true
    },
    "taskList": {
      handler(newVal, oldVal) {
        console.log("this.taskList", this.taskList);
        this.checkTask();
      },
      deep: true,
      immediate: true
    },
    "advList": {
      handler(newVal, oldVal) {
        console.log("this.advList", this.advList);
        this.checkTask();
        this.getFadvList();
      },
      deep: true,
      immediate: true
    },
    "selectTab": {
      async handler(newVal, oldVal) {
        if (newVal == 1) {
          this.getSummary();
        }
      },
      deep: true,
      immediate: true
    }
  },
  async mounted() {
    if (this.taskList.length == 0) await this.getTaskList();

    //if(this.advList.length == 0)
    await this.getAdvList();
    this.countDown();
    // if(this.selectTab == 1){
    this.getSummary();
    //}
  },

  methods: {
    ...walletVuex.mapActions(["loadTaskCount"]),
    ...userVuex.mapMutations(['setUserData']),
    ...taskVuex.mapActions(['getTaskList', 'getAdvList']),
    ...taskVuex.mapMutations(['setSelectTab']),
    ...dailyVuex.mapActions(['getSummary']),
    onUpGold() {
      this.popUpGoldShow = true;
    },
    onCoinHero() {
      this.popCoinHeroShow = true;
    },
    onBindWallet() {
      // this.$nextTick(() => {
      //   this.tonWallet.openOrCloseTonModal(true);
      // });
      // if(this.userData.bind_wallet) return
      this.popBindWalletShow = true;
    },
    async onJoin(type, url, extra) {
      console.log("url=====", url);
      if (type == 'telegram' || type == 'channel') {
        this.WebApp.openTelegramLink(url);
      } else {
        this.WebApp.openLink(url);
      }
      if (!this.userData[`joined_${type}`]) {
        this.doCheckJoin(type);
      }
      // this.$loading.show();
      // setTimeout(()=>{
      //   this.$loading.hide();
      // },1000)
    },

    async doCheckJoin(type) {
      if (this.checkNum >= 5) {
        this.checkNum = 0;
        return;
      }
      this.checkNum++;
      let rs = await this.$http.post("/my/social/join", {
        target: type
      });
      if (rs.code == 0) {
        let newUserData = {
          ...this.userData,
          ...(rs.data.userInfo ? rs.data.userInfo : rs.data)
        };
        this.setUserData(newUserData);
        this.loadTaskCount();
      } else if (rs.code == 302) {
        setTimeout(() => {
          this.doCheckJoin(type);
        }, 2000);
      }
    },
    onAccept() {
      this.isPopRewardResultShow = false;
    },
    async onExtralJoin(item, adv = 0) {
      console.log("url=====", item.url);
      if ((item.type || '') == 'adsgram' || (item.provider || '') == 'adsgram') {
        this.$loading.show();
        this.selectRow = {
          value: item.reward,
          unit: this.setting.coin,
          type: "tapcoins"
        };
        if (this.selectRow.unit == 'TAP') {
          this.selectRow.unit = 'TAPS';
        }
        const AdController = await window.Adsgram.init({
          blockId: item.url
        });
        await AdController.show().then(result => {
          // user watch ad till the end
          // your code to reward user
          this.$loading.hide();
          if (result.done && !item.completed) this.checkExtralTask(item, adv);
        }).catch(result => {
          // user skipped video or get error during playing ad
          // do nothing or whatever you want
          console.log(result);
          this.$loading.hide();
        });
        this.$loading.hide();
        return;
      }
      if ((item.type || '') == 'openad' || (item.provider || '') == 'openad') {
        this.$loading.show();
        this.selectRow = {
          value: item.reward,
          unit: this.setting.coin,
          type: "tapcoins"
        };
        if (this.selectRow.unit == 'TAP') {
          this.selectRow.unit = 'TAPS';
        }
        const adParams = {
          version: '',
          // your app version if there is no data, please leave it blank
          TG: true // If it is required for Telegram TMA application, and the value is true.
        };

        let dataParams = item.url.split("|");
        const adInfo = {
          zoneId: Number(dataParams[0]),
          // example zoneId, please check your own code parameters
          publisherId: Number(dataParams[1]),
          // example publisherId, please check your own code parameters
          eventId: 0 // Reserved Parameter
        };

        const userInfo = {
          userId: "",
          // user Id, Telegram TMA please leave it blank, webApp if there is no data, please leave it blank
          firstName: "",
          // firstName or userId, Telegram TMA please leave it blank, webApp if there is no data, please leave it blank
          lastName: "",
          // lastName or userId, Telegram TMA please leave it blank, webApp if there is no data, please leave it blank
          userName: "",
          // username or userId, Telegram TMA please leave it blank, webApp if there is no data, please leave it blank
          walletType: "",
          // user wallet type: TON / EVM / TRON / other blockchain project names,  if there is no data, please leave it blank
          walletAddress: "" // user wallet address,  if there is no data, please leave it blank
        };

        let res = await window.openADJsSDK.interactive.init({
          adParams,
          adInfo,
          userInfo
        });
        this.$loading.hide();
        if (res.code === 0) {
          const callbackFunc = {
            // Indicates load ad resource from OpenAD platform, false will be returned if there is no resource to be loaded for the publisher slot/zone
            adResourceLoad: e => {
              // 'step1', e = ture / false
            },
            // Indicates the interactive ad is opening
            adOpening: e => {
              // 'step2', e = ture / false
            },
            // Indicates the interactive ad is opened,
            adOpened: e => {
              // 'step3',  e = ture / false
            },
            // indicates the interactive ad task is finished, the task is defined by publisher
            adTaskFinished: e => {
              // 'step5',  e = viewAD / click  / close
              if (!item.completed) this.checkExtralTask(item, adv);
            },
            // Indicates the interactive ad is closing
            adClosing: e => {
              // 'step6', e = viewAD / click  / close
            },
            // Indicates the interactive ad is closed
            adClosed: e => {
              // 'step7', e = viewAD / click / close
              // If you want to perform different steps based on different shutdown states, please write the code here.
            },
            // Indicates clicked and jumps
            adClick: e => {
              // 'step4', e = ture / false
            }
          };

          // Call SDK method to get advertising and render data
          window.openADJsSDK.interactive.getRender({
            adInfo,
            cb: callbackFunc
          });
        }
        return;
      }
      if ((item.type || '') == 'tonai' || (item.provider || '') == 'tonai') {
        this.$loading.show();
        this.selectRow = {
          value: item.reward,
          unit: this.setting.coin,
          type: "tapcoins"
        };
        let params = {
          appId: '676a5db777f388016248ad84',
          debug: false
        };
        window.TonAISdk.TonAdInit(params);
        const blockId = item.url;
        const limit = 5;
        window.TonAISdk.GetMultiTonAd(blockId, limit).then(res => {
          this.$loading.hide();
          let ads = res.ads;
          if (ads && ads.length > 0) {
            let idx = Math.floor(Math.random() * (ads.length - 1));
            // 广告加载成功，可以在适当的时机展示
            window.TonAISdk.TonAdPopupShow({
              tonAd: ads[idx],
              // 用户点击的广告对象
              countdown: 15,
              // 可以不设置，默认值为 10 秒，最小值为 10 秒，最大值为 30 秒
              autoClose: true,
              // 默认值为 true，表示广告倒计时结束后自动关闭广告
              onAdComplete: ad => {
                // 用户看完了广告, 可以在此发放奖励
                // sendReward(ad)
                this.checkExtralTask(item, adv);
              },
              onAdClick: ad => {
                // 用户点击了广告, 可以在此发放奖励
                // sendReward(ad)
                this.checkExtralTask(item, adv);
              },
              onAdError: error => {
                // 用户在播放广告时遇到错误
                console.error(error);
              },
              onAdClose: ad => {
                // 用户手动关闭了广告
              }
            });
          } else {
            // 没有可用的广告
          }
        }).catch(error => {
          this.$loading.hide();
          console.error('加载广告失败:', error);
        });
        return;
      } else if ((item.type || '') == 'tmads' || (item.provider || '') == 'tmads') {
        this.$loading.show();
        this.selectRow = {
          value: item.reward_token_symbol === 'TAP' ? item.reward_token : item.reward,
          unit: item.reward_token_symbol || this.setting.coin,
          type: item.reward_token_symbol ? item.reward_token_symbol.toLowerCase() : "tapcoins"
        };
        this.selectRow = {
          value: item.reward,
          unit: this.setting.coin,
          type: "tapcoins"
        };
        TMAds.init({
          app_key: item.url,
          init_data: this.WebApp.initData,
          init_data_unsafe: this.WebApp.initDataUnsafe
        });
        TMAds.showInterstitialAd().then(() => {
          //interstitial ad has been successfully shown and closed
          this.$loading.hide();
          if (!item.completed) this.checkExtralTask(item, adv);
        }).catch(() => {
          //interstitial ad failed to show (likely due to the network issues)
          this.$loading.hide();
        });
        return;
      } else if ((item.type || '') == 'matrix') {
        if (!item.completed) {
          this.$router.push(`/taskDetail?id=${item.id}`);
        }
        return;
      } else if (((item.type || '') == 'adcloud' || (item.provider || '') == 'adcloud') && this.userLocation.googleAdvType == 'inner') {
        if (!item.completed) {
          this.$loading.show();
          this.itemData = item;
          this.itemData.adv = adv;
          this.iframeUrl = item.url;
          this.iframeShow = true;
          this.selectRow = {
            value: item.reward_token_symbol === 'TAP' ? item.reward_token : item.reward,
            unit: item.reward_token_symbol ? item.reward_token_symbol : this.setting.coin,
            type: item.reward_token_symbol ? item.reward_token_symbol.toLowerCase() : "tapcoins"
          };
          this.$nextTick(() => {
            this.$set(this.itemData, 'adv_countdown', 10);
            this.$refs.iframDiv.style.top = '0px';
            this.advCountDown();
            this.WebApp.BackButton.hide();
          });
          this.$loading.hide();
        }
        return;
      } else if ((item.type || '') == 'page') {
        if (item.target == 'BindOkxWallet') {
          if (!item.completed) {
            this.itemData = item;
            this.popBindOkxWalletShow = true;
          }
        } else {
          //if(!item.completed)
          this.$router.push(`/${item.target}?id=${item.id}`);
        }
        return;
      } else if (item.type == 'telegram' || item.type == 'channel') {
        //this.WebApp.openTelegramLink(item.url)
      } else if ((item.type || '') == 'adcloud' || (item.provider || '') == 'adcloud') {
        this.WebApp.openLink(item.url);
      } else {
        //this.WebApp.openLink(item.url)
      }
      this.itemData = item;
      this.itemData.adv = adv;
      this.selectRow = {
        value: item.reward_token_symbol === 'TAP' ? item.reward_token : item.reward,
        unit: item.reward_token_symbol ? item.reward_token_symbol : this.setting.coin,
        type: item.reward_token_symbol ? item.reward_token_symbol.toLowerCase() : "tapcoins"
      };
      this.popEarnTipShow = true;
      // this.checkNum = 0;
      // if(!item.completed){
      //   item.completed = -1
      //   setTimeout(()=>{
      //     this.checkExtralTask(item,adv);
      //   },10000)
      // }
    },

    async checkExtralTask(item, adv) {
      if (this.checkNum >= 5) {
        this.checkNum = 0;
        return;
      }
      this.checkNum++;
      let rs = await this.$http.post("/task/complete", {
        taskId: item.id,
        adv: adv
      });
      if (rs.code == 0) {
        item.completed = 1;
        //if(adv == 1 && item.cyclical == 1){
        if (item.cyclical == 1) {
          item.countdown = item.cycle_interval;
        }
        let newUserData = {
          ...this.userData,
          ...(rs.data.userInfo ? rs.data.userInfo : rs.data)
        };
        this.setUserData(newUserData);
        if (((item.type || '') == 'adcloud' || (item.provider || '') == 'adcloud') && this.userLocation.googleAdvType == 'inner') this.isPopRewardResultShow = false;else this.isPopRewardResultShow = true;
        this.getFadvList();
        if (adv == 0) this.loadTaskCount();
      } else if (rs.code == 302) {
        setTimeout(() => {
          this.checkExtralTask(item, adv);
        }, 2000);
      }
    },
    checkTask() {
      this.taskNum = 0;
      this.extraTaskNum = 0;
      if ((this.setting.reward.bindWallet || this.setting.reward.bindWalletStock) && !this.userData.bind_wallet) this.taskNum += 1;
      for (let key in this.setting.socials) {
        if (this.setting.socials[key]) {
          switch (key) {
            case "channel":
              if (this.userData.joined_channel == 0) {
                this.taskNum += 1;
              }
              break;
            case "discord":
              if (this.userData.joined_discord == 0) {
                this.taskNum += 1;
              }
              break;
            case "telegram":
              if (this.userData.joined_telegram == 0) {
                this.taskNum += 1;
              }
              break;
            case "twitter":
              if (this.userData.joined_twitter == 0) {
                this.taskNum += 1;
              }
              break;
          }
        }
      }
      this.taskList.map(item => {
        if (item.completed == 0) {
          if (item.is_official == 0) this.extraTaskNum += 1;else if (item.is_official == 1) this.taskNum += 1;
        }
      });
      this.advList.map(item => {
        if (item.completed == 0) {
          this.taskNum += 1;
        }
      });
    },
    onSkip(page) {
      this.$router.push(`/${page}`);
    },
    onTab(t) {
      this.setSelectTab(t);
    },
    countDown() {
      clearTimeout(this.timeVal);
      this.advList.map(item => {
        if (item.cyclical == 1 && item.countdown > 0) {
          item.countdown = item.countdown - 1;
          if (item.countdown <= 0) {
            item.completed = 0;
          }
        }
      });
      this.taskList.map(item => {
        if (item.cyclical == 1 && item.completed == 1) {
          item.countdown = item.countdown - 1;
          if (item.countdown <= 0) {
            item.completed = 0;
          }
        }
      });
      this.getFadvList();
      this.timeVal = setTimeout(() => {
        this.countDown();
      }, 1000);
    },
    advCountDown() {
      clearTimeout(this.stimeVal);
      this.itemData.adv_countdown = this.itemData.adv_countdown - 1;
      if (this.itemData.adv_countdown <= 0) {
        this.itemData.completed = 1;
        this.$set(this.itemData, 'completed', 1);
        this.checkExtralTask(this.itemData, this.itemData.adv);
      } else {
        this.stimeVal = setTimeout(() => {
          this.advCountDown();
        }, 1000);
      }
    },
    onLucky() {
      this.$router.push(`/youtube?id=${this.setting.lucky_code_id}`);
    },
    closeIframDiv() {
      if (this.itemData.adv_countdown > 0) return;
      this.WebApp.BackButton.show();
      this.iframeShow = false;
      this.isPopRewardResultShow = true;
    },
    getFadvList() {
      this.fadvList = [];
      this.advList.map(item => {
        if (item.completed !== 1 && this.fadvList.length < 4) {
          this.fadvList.push(item);
        }
      });
    }
  }
};